export var en = {
    translation: {
        button: {
            backToAccountServices: 'BACK TO ACCOUNT SERVICES',
            changeDueDate: 'Change Due Date',
            close: 'CLOSE'
        },
        changePaymentDueDate: 'Change payment due date',
        currentPaymentDueDate: 'Current Payment Due Date',
        disclaimer: {
            disclaimer: 'By selecting “Change Due Date” we will process your Due Date Change request. Your Minimum Payment Due may increase on your next statement as a result of this request.',
            note: '<strong>Note:</strong> You are allowed 1 due date change in a 12 month period.'
        },
        errorMessages: {
            dueDateChangePeriodRestriction: {
                title: 'You can’t change your due date right now',
                subTitle: 'You can change your due date once every 12 months.'
            },
            notEligible: {
                title: 'Your account is not eligible',
                body: 'We cannot process your request for Change Due Date at this time.'
            },
            troubleRetrievingInformation: 'We’re having trouble retrieving your information',
            tryAgainLater: 'Please try again later.'
        },
        header: {
            currentDueDate: {
                date: '{{date}} of every month',
                title: 'CURRENT PAYMENT DUE DATE'
            },
            selectDateError: 'Please select a new due date.',
            selectTheDate: 'Select the date below you would like to set as your new payment due date',
            title: 'Change your Due Date'
        },
        modalHeader: 'Change Due Date',
        promosExtendedMessageBox: {
            body: 'Please reference your next statement to view your adjusted promotion expiration date.',
            title: 'The expiration date of your existing promotion has changed'
        },
        selectedDueDate: 'Selected Due Date',
        successfulScreen: {
            currentDate: '{{date}} of the month',
            currentPaymentDueDate: 'Current Statement Payment Due Date',
            details: 'Details',
            newDate: '{{date}} of the month',
            newPaymentDueDate: 'New Payment Due Date',
            note: '<strong>Note:</strong> If you are enrolled in Autopay, this change will also apply to your autopay payments.',
            subTitleOne: 'The change to your due date will first appear on your next billing statement.',
            subTitleTwo: 'Until then, your current due date will not change.',
            title: 'You have successfully changed your due date'
        },
        unableToProcessRequest: 'Unfortunately we are unable to process your request at this time.'
    }
};
